<div class="chat-choice" [class.chat-choice--locked]="locked">
  @if (showLabel) {
    <div class="chat-choice__label">
      {{ fieldLabel }} for {{ passengerName }}
      @if (isMandatory) {
        <span class="chat-choice__required" aria-hidden="true">*</span>
      }
    </div>
  }

  @if (locked && chosenSummary) {
    <div class="chat-choice__chosen">{{ chosenSummary }}</div>
  }

  <label class="chat-choice__field-wrap">
    <span class="chat-choice__field-label">{{ fieldLabel }}</span>
    <select [disabled]="locked" [(ngModel)]="selectedValue" (ngModelChange)="onSelectionChanged()">
      <option value="">{{ placeholder || 'None' }}</option>
      @for (choice of choices; track choice.value) {
        <option [value]="choice.value">{{ choice.title }}</option>
      }
    </select>
  </label>

  @if (infoForValue && selectedChoiceText.includes(infoForValue)) {
    <div class="chat-choice__info" role="note">
      You can collect your ticket from
      <strong>{{ infoMessageStationName }}</strong>
      or over
      <a
        href="https://support.thetrainline.com/en/support/solutions/articles/78000000556"
        target="_blank"
        rel="noopener noreferrer"
        >1500 stations</a
      >
      listed, but you must collect your tickets before you start your journey.
      <br /><br />
      <strong>Note:</strong> To collect your tickets from the station you will need a valid payment
      card and your collection reference. No charges will be made to the card used.
    </div>
  }

  @if (emailForValue && selectedChoiceText.includes(emailForValue)) {
    <label class="chat-choice__field-wrap">
      <span class="chat-choice__field-label">{{ emailLabel }}</span>
      <input
        type="email"
        [disabled]="locked"
        [(ngModel)]="emailValue"
        [attr.aria-label]="emailLabel"
      />
    </label>
  } @else if (stationForValue && selectedChoiceText.includes(stationForValue)) {
    <label class="chat-choice__field-wrap">
      <span class="chat-choice__field-label">{{ stationLabel }}</span>
      <input
        type="text"
        placeholder="Enter a ticket on departure station"
        id="schemamandatoryiftod-input-todStationCode"
        [ngbTypeahead]="railLocations"
        [resultTemplate]="stationResult"
        [inputFormatter]="formatterStation"
        (selectItem)="onStationSelected($event)"
        (ngModelChange)="onStationValueChanged($event)"
        [disabled]="locked"
        [(ngModel)]="stationValue"
        [attr.aria-label]="stationLabel"
        required
      />
      <ng-template #stationResult let-station="result">{{ station.name }}</ng-template>
    </label>
  }

  <div class="chat-choice__actions">
    @if (showSkip && !isMandatory) {
      <button type="button" class="chat-choice__skip" [disabled]="locked" (click)="onSkip()">
        Skip
      </button>
    }
    <button
      type="button"
      class="chat-choice__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
